"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@chakra-ui/react");
var _react2 = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const ImagePreviewWarningAlert = ({
  imageCount,
  onGeneratePreviews
}) => {
  const {
    isOpen: isVisible,
    onClose
  } = (0, _react.useDisclosure)({
    defaultIsOpen: true
  });
  const [isLoading, setIsLoading] = (0, _react2.useState)(false);
  if (!isVisible) {
    return null;
  }
  const handleGeneratePreviews = async () => {
    setIsLoading(true);
    await onGeneratePreviews();
    setIsLoading(false);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Alert, {
    status: "warning",
    variant: "subtle",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    mb: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.AlertIcon, {
      boxSize: 4,
      mr: 0
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.AlertTitle, {
      mt: 4,
      mb: 1,
      fontSize: "lg",
      children: ["Missing Previews for ", imageCount, " Images"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.AlertDescription, {
      maxWidth: "container.lg",
      children: ["There are ", imageCount, " images in your collection that currently lack previews. To enhance the browsing experience and facilitate easy selection, it is recommended to generate previews for these images."]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.ButtonGroup, {
      mt: 4,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Button, {
        colorScheme: "blue",
        onClick: handleGeneratePreviews,
        isLoading: isLoading,
        children: isLoading ? 'Generating...' : 'Generate Previews'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Button, {
        variant: "ghost",
        onClick: onClose,
        children: "Remind Me Later"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.CloseButton, {
      position: "absolute",
      right: "8px",
      top: "8px",
      onClick: onClose
    })]
  });
};
var _default = ImagePreviewWarningAlert;
exports.default = _default;